/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "../../../component/button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import classes from "./createPackage.module.css";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import Loader from "../../../component/loader";
import Chip from "@mui/material/Chip";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import {
  AddIcon,
  PlusIcon,
  ViewIcon,
  ViewIconNew,
} from "../../../component/icons/icons";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConfigurationResource from "../component/configurationResource";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import Filter1Icon from "@mui/icons-material/Filter1";
import ComponentAssembly from "./componentAssembly";
import { LooksOneOutlined, FilterNoneOutlined } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import { Menu, Select, styled } from "@mui/material";
import currencyFormatter from "../../../helper/currencyFormatter";
import Pagination from "@mui/material/Pagination";
import Input from "../../../component/inputpm";
import IconButton from "@mui/material/IconButton";
import { SearchIcon, ClearIcon } from "../../../component/icons/icons";
import Draggable from "react-draggable";
import { Checkbox } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
// import { withStyles } from '@mui/styles';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { formatNumber } from "../../../helper/numberFormatter";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";

class PackageTemplate extends Component {
  state = {
    fullWidth: true,
    maxWidth: "md",
    loading: false,
    data: [],
    dataProxy: [],
    step: 1,
    selectedToView: {},
    provisioningResources: [],
    activationResources: [],
    suspendResources: [],
    resumeResources: [],

    showDefaultValue: false,

    selectedFulfilmentResource: {},
    fulfilmentConnectionFields: {},
    fulfilmentTableFields: [],
    fulfilmentTableEditable: false,

    selectedActivationResource: {},
    activationConnectionFields: {},
    activationTableFields: [],
    activationTableEditable: false,
    activationFile: "",

    selectedSuspendResource: {},
    suspendConnectionFields: {},
    suspendTableFields: [],
    suspendTableEditable: false,

    selectedResumeResource: {},
    resumeConnectionFields: {},
    resumeTableFields: [],
    resumeTableEditable: false,
    openDropdownMenu: false,
    anchorEl: null,

    page: 1,
    perPage: 10,
    startRecord: 1,
    totalProductsCount: 0,

    searchFilter: {
      name: "",
      featureCode: "",
      type: "",
    },
    allComponentsList: [],
    selectedToAdd: [],
    selectAll: false,

    startRecord: 1,
    totalProductsCount: 0,
    sortBy: "productName",
    sortOrder: "ASC",
    partnerList: [],
    selectedPartner: "",
    partnerProducts: false,
  };

  componentDidMount() {
    this.getProductsList();
    this.getResources();
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ASSOC_PARTNERS/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data.list;
        this.setState({ partnerList: list });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  }
  getProductsList() {
    this.setState({ loading: true });
    let search = new URLSearchParams(window.location.search);
    let addToCatalog = search.get("addToCatalog");
    let pageOptions = {
      batchSize: this.state.perPage,
      startRecord: this.state.startRecord,
    };
    if (this.props.component == "PROD_COMP_PACKAGE") {
      BusApiCall(
        "GET",
        `${constants.busV4Url2}/productOfferings?productCategoryId=PKG${this.state.searchFilter.name ? "&productName=" + this.state.searchFilter.name : ""}&sortBy=name&sortOrder=${this.state.sortOrder}`,
        {},
        pageOptions,
      )
        .then((res) => {
          let data = res.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i] != undefined) {
              data[i].id = data[i].productOfferingId;
              if (data[i].price != null) {
                data[i].priceType = data[i].price.priceType;
                data[i].price = data[i].price.priceAmount;
              }
              if (data[i].productCode) {
                data[i].featureCode = data[i].productCode;
              }
              data[i].componentType = this.props.component;
            }
          }
          for (var j = 0; j < this.props.components.length; j++) {
            for (var i = 0; i < data.length; i++) {
              if (
                (this.props.components[j].id === data[i].id ||
                  this.props.components[j].name === data[i].name) &&
                !this.props.components[j].remove
              ) {
                data.splice(i, 1);
              }
              if (data[i] != undefined) {
                data[i].componentType = this.props.component;
                data[i].isExistingProduct = true;
                data[i].solutionPlansCopy = this.props.solutionPlansCopy;
                if (data[i].price != null) {
                  data[i].price = JSON.parse(data[i].price).toFixed(2);
                }
                // if (addToCatalog === 'true') {
                //     if (data[i].fromProviderType === this.props.providerType) {
                //         if (data[i].fromProviderId !== this.props.providerId) {
                //             data[i].featureCode = '';
                //         }
                //     } else {
                //         data[i].featureCode = '';
                //     }
                // }
              }
            }
          }
          this.setState(
            {
              // data: data,
              dataProxy: JSON.parse(JSON.stringify(data)),
              allComponentsList: JSON.parse(JSON.stringify(data)),
              totalProductsCount: +res.headers["x-total-count"],
            },
            () => {
              this.setState({
                data: data,
                loading: false,
              });
            },
          );
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    } else {
      // https://localhost:8253/cumulator/api/v4/availableProducts?productType=PROD_COMP_TPS&sortBy=productName&sortOrder=ASC
      // BusApiCall('GET', `${constants.busV4Url}/catalogs/products?componentType=${this.props.component}&mode=pmui&customer=${this.props.selectedCustomer ? this.props.selectedCustomer : ''}`).then(res => {
      // BusApiCall('GET', `${constants.busV4Url}/catalogs/products?componentType=${this.props.component}&mode=pmui${this.state.searchFilter.name ? '&name=' + this.state.searchFilter.name : ''}${this.state.searchFilter.featureCode ? '&code=' + this.state.searchFilter.featureCode : ''}`, {}, pageOptions).then(res => {
      BusApiCall(
        "GET",
        `${constants.busV4Url}/availableProducts?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&partnerProducts=${this.state.partnerProducts}&productType=${this.props.component}${this.state.searchFilter.name ? "&name=" + this.state.searchFilter.name : ""}${this.state.searchFilter.featureCode ? "&code=" + this.state.searchFilter.featureCode : ""}${this.state.selectedPartner ? "&partnerId=" + this.state.selectedPartner : ""}`,
        {},
        pageOptions,
      )
        .then((res) => {
          let data = res.data;
          let removedCount = 0;
          for (var j = 0; j < this.props.components.length; j++) {
            for (var i = 0; i < data.length; i++) {
              //check if the component is already added: To avoid duplicate selection of the component
              //if(this.props.components[j].existing != undefined && this.props.components[j].existing)
              // if ((this.props.components[j].id === data[i].id || this.props.components[j].name === data[i].name || this.props.components[j].featureCode === data[i].featureCode )
              if (
                (this.props.components[j].id === data[i].id ||
                  this.props.components[j].featureCode ===
                  data[i].featureCode) &&
                !this.props.components[j].remove
              ) {
                data.splice(i, 1);
                removedCount++;
              }
              if (data[i] != undefined) {
                data[i].isExistingProduct = true;
                data[i].solutionPlansCopy = this.props.solutionPlansCopy;
                if (data[i].price != null) {
                  data[i].price = JSON.parse(data[i].price).toFixed(2);
                }
                // if (addToCatalog === 'true') {
                //     if (data[i].fromProviderType === this.props.providerType) {
                //         if (data[i].fromProviderId !== this.props.providerId) {
                //             data[i].featureCode = '';
                //         }
                //     } else {
                //         data[i].featureCode = '';
                //     }
                // }
              }
            }
          }
          this.setState(
            {
              // data: data,
              data: JSON.parse(JSON.stringify(data)),
              allComponentsList: JSON.parse(JSON.stringify(data)),
              totalProductsCount: +res.headers["x-total-count"] - removedCount,
            },
            () => {
              this.setState({
                loading: false,
              });
            },
          );
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  }

  changePage = (e, page) => {
    this.setState(
      {
        page: page,
        startRecord: this.state.perPage * (page - 1) + 1,
      },
      () => {
        this.getProductsList();
      },
    );
  };

  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getProductsList();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getProductsList();
        },
      );
    }
  };

  togglePartnerProducts = (e) => {
    this.setState(
      {
        partnerProducts: !this.state.partnerProducts,
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getProductsList();
      },
    );
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  changeRowsPerPage = (event) => {
    this.setState(
      {
        perPage: event.target.value,
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getProductsList();
      },
    );
  };

  paginate = () => {
    if (this.state.dataProxy && this.state.dataProxy.length > 0) {
      return this.state.dataProxy.slice(
        (this.state.page - 1) * this.state.perPage,
        this.state.page * this.state.perPage,
      );
    } else {
      return [];
    }
  };

  updateFilter = (e) => {
    let filter = { ...this.state.searchFilter };
    filter[e.target.name] = e.target.value;
    this.setState({
      searchFilter: filter,
    });
  };

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterComponents();
    }
  };

  filterComponents = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        totalProductsCount: 0,
      },
      () => {
        this.getProductsList();
      },
    );
    // let allComponents = [...this.state.allComponentsList];
    // let filters = { ...this.state.searchFilter };
    // let filteredComponents = allComponents.filter((element) => {
    //     let name = element.name.toLowerCase();
    //     let featureCode = element.featureCode ? element.featureCode.toLowerCase() : '';
    //     return name.includes(filters.name.toLocaleLowerCase()) && featureCode.includes(filters.featureCode.toLocaleLowerCase());
    // });
    // this.setState({
    //     dataProxy: filteredComponents,
    //     page: 1,
    //     perPage: 10,
    // }, () => {
    //     this.setState({
    //         data: this.paginate(),
    //     })
    // })
  };

  clearFilters = () => {
    this.setState(
      {
        searchFilter: {
          name: "",
          featureCode: "",
          type: "",
          page: 1,
          perPage: 10,
          totalProductsCount: 0,
        },
      },
      () => {
        this.getProductsList();
      },
    );
  };

  getShortenedChipName = (chipText) => {
    let shortenedText = chipText;
    if (shortenedText && shortenedText.length > 25) {
      shortenedText =
        shortenedText.substring(0, 5) +
        "....." +
        shortenedText.substring(shortenedText.length - 15);
    }
    return shortenedText;
  };

  viewComponent = (item) => {
    var selectedFulfilmentResource = {};
    var selectedActivationResource = {};
    var selectedSuspendResource = {};
    var selectedResumeResource = {};
    if (item.provisioning && item.provisioning.resourceId) {
      selectedFulfilmentResource = this.state.provisioningResources.find(
        (x) => x.resourceId === item.provisioning.resourceId,
      );
      if (selectedFulfilmentResource) {
        selectedFulfilmentResource.targetAddress =
          item.provisioning.targetAddress;
        if (item.provisioning.extraFields) {
          this.setState({
            fulfilmentConnectionFields: item.provisioning.extraFields,
          });
        }
        if (item.provisioning.parameters) {
          this.setState({
            fulfilmentTableFields: JSON.parse(item.provisioning.parameters),
          });
        }
        if ("STD_VM_PROV" === item.provisioning.resourceId) {
          this.setState({
            showDefaultValue: true,
          });
        }
      }
    }
    if (item.activation && item.activation.resourceId) {
      selectedActivationResource = this.state.activationResources.find(
        (x) => x.resourceId === item.activation.resourceId,
      );
      if (selectedActivationResource) {
        selectedActivationResource.targetAddress =
          item.activation.targetAddress;
        if (item.activation.extraFields) {
          this.setState({
            activationConnectionFields: item.activation.extraFields,
          });
        }
        if (item.activation.parameters) {
          this.setState({
            activationTableFields: JSON.parse(item.activation.parameters),
          });
        }
      }
    }
    if (item.suspendResource && item.suspendResource.resourceId) {
      selectedSuspendResource = this.state.suspendResources.find(
        (x) => x.resourceId === item.suspendResource.resourceId,
      );
      if (selectedSuspendResource) {
        selectedSuspendResource.targetAddress =
          item.suspendResource.targetAddress;
        if (item.suspendResource.extraFields) {
          this.setState({
            suspendConnectionFields: item.suspendResource.extraFields,
          });
        }
        if (item.suspendResource.parameters) {
          this.setState({
            suspendTableFields: JSON.parse(item.suspendResource.parameters),
          });
        }
      }
    }
    if (item.resumeResource && item.resumeResource.resourceId) {
      selectedResumeResource = this.state.resumeResources.find(
        (x) => x.resourceId === item.resumeResource.resourceId,
      );
      if (selectedResumeResource) {
        selectedResumeResource.targetAddress =
          item.resumeResource.targetAddress;
        if (item.resumeResource.extraFields) {
          this.setState({
            resumeConnectionFields: item.resumeResource.extraFields,
          });
        }
        if (item.resumeResource.parameters) {
          this.setState({
            resumeTableFields: JSON.parse(item.resumeResource.parameters),
          });
        }
      }
    }
    this.setState({
      selectedToView: item,
      selectedFulfilmentResource: selectedFulfilmentResource
        ? selectedFulfilmentResource
        : {},
      selectedActivationResource: selectedActivationResource
        ? selectedActivationResource
        : {},
      selectedSuspendResource: selectedSuspendResource
        ? selectedSuspendResource
        : {},
      selectedResumeResource: selectedResumeResource
        ? selectedResumeResource
        : {},
      step: 2,
    });
  };

  clearSelectedItemResourcesTable = () => {
    this.setState({
      showDefaultValue: false,

      selectedFulfilmentResource: {},
      fulfilmentConnectionFields: {},
      fulfilmentTableFields: [],
      fulfilmentTableEditable: false,

      selectedActivationResource: {},
      activationConnectionFields: {},
      activationTableFields: [],
      activationTableEditable: false,
      activationFile: "",

      selectedSuspendResource: {},
      suspendConnectionFields: {},
      suspendTableFields: [],
      suspendTableEditable: false,

      selectedResumeResource: {},
      resumeConnectionFields: {},
      resumeTableFields: [],
      resumeTableEditable: false,

      selectedToView: {},
    });
  };

  //configuration methods
  getResources = () => {
    this.setState({
      activationResources: this.props.activationResources,
      provisioningResources: this.props.provisioningResources,
      suspendResources: this.props.suspendResources,
      resumeResources: this.props.resumeResources,
    });
  };

  handleClose = (type) => {
    if (type === "component") {
      this.props.addComponent("component");
    } else if (type === "assembly") {
      this.props.addComponent("assembly");
    }
    this.setState({
      anchorEl: null,
      openDropdownMenu: !this.state.openDropdownMenu,
    });
  };

  handleClick = (event) => {
    // setAnchorEl(event.currentTarget);
    this.setState({
      anchorEl: event.currentTarget,
      openDropdownMenu: !this.state.openDropdownMenu,
    });
  };

  handlePartnerSelection = (event) => {
    this.setState({
      selectedPartner: event.target.value,
    });
  };

  render() {
    const { t } = this.props;
    const StyledMenu = styled((props) => (
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        {...props}
      />
    ))(({ theme }) => ({
      "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: 35,
        minWidth: 180,
        color:
          // theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
          "rgba(0, 0, 0, 0.8)",
        boxShadow:
          "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
          padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
          "& .MuiSvgIcon-root": {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
          },
        },
      },
    }));
    const getPriceTenureUOM = (val) => {
      if (val === "TF_day") {
        return "Day";
      } else if (val === "TF_hr" || val === "HOUR") {
        return "Hour";
      } else if (val === "TF_wk") {
        return "Week";
      } else if (val === "TF_mon") {
        return "Month";
      } else if (val === "TF_qtr") {
        return "Quarterly";
      } else if (val === "TF_yr") {
        return "Year";
      } else if (val === "YEAR") {
        return "Year";
      } else if (val === "DAY") {
        return "Day";
      } else if (val === "WEEK") {
        return "Week";
      } else if (val === "MONTH") {
        return "Month";
      } else {
        return "";
      }
    };
    const updateSelection = (value) => {
      var selectedItems = [...this.state.selectedToAdd];
      const existingIndex = selectedItems.findIndex(
        (item) => item.featureCode === value.featureCode,
      );
      if (existingIndex > -1) {
        selectedItems.splice(existingIndex, 1);
      } else {
        selectedItems.push(value);
      }
      this.setState(
        {
          selectedToAdd: selectedItems,
          selectAll: false,
        },
        () => {
          // console.log('selectedItems:=======', this.state.selectedToAdd);
        },
      );
    };

    return (
      <div className={classes.root}>
        <Dialog
          disableScrollLock={true}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={this.state.fullWidth}
          // maxWidth={this.state.maxWidth}
          maxWidth={false}
          // PaperComponent={this.draggableDialogPaper}
          PaperComponent={DraggableResizablePaper}
          PaperProps={{
            style: {
              width: '70vw',
              maxWidth: '90vw',
              minWidth: '70vw',
              height: '50vh',
              maxHeight: '90vh',
              minHeight: '30vh',
            }
          }}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {this.state.step === 1 && t("CHOOSE") + " " + this.props.name}
            {(this.state.step === 2 || this.state.step === 3) &&
              this.props.name + " > " + this.state.selectedToView.name}
            {this.props.component !== "PROD_COMP_PACKAGE" && (
              <>
                {/* {(this.props.enabledModules.INVENTORY && this.props.enabledModules.INVENTORY.enabled) ?
                                    <>
                                        <Button
                                            id="demo-customized-button"
                                            aria-controls={this.state.openDropdownMenu ? 'demo-customized-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={this.state.openDropdownMenu ? 'true' : undefined}
                                            variant="contained"
                                            disableElevation
                                            onClick={this.handleClick}
                                            endIcon={<KeyboardArrowDownIcon />}
                                            style={{ float: 'right', marginLeft: '8px' }}
                                        >
                                            {t('ADD')}
                                        </Button>
                                        <StyledMenu
                                            id="demo-customized-menu"
                                            MenuListProps={{
                                                'aria-labelledby': 'demo-customized-button',
                                            }}
                                            anchorEl={this.state.anchorEl}
                                            open={this.state.openDropdownMenu}
                                            onClose={this.handleClose}
                                        >
                                            <MenuItem onClick={() => this.handleClose('component')} disableRipple>
                                                {t('ADD_COMPONENT')}
                                            </MenuItem>
                                            <MenuItem onClick={() => this.handleClose('assembly')} disableRipple>
                                                {t('ADD_ASSEMBLY')}
                                            </MenuItem>
                                        </StyledMenu>
                                    </>
                                    :
                                    <>
                                        <Button style={{ float: 'right', marginLeft: '8px' }} onClick={event => this.handleClose('component')}>{this.props.t('NEW') + ' ' + this.props.name}</Button>
                                    </>
                                } */}
                {/* <Button style={{ float: 'right', marginLeft: '8px' }} onClick={event => this.handleClose('component')}>{this.props.t('NEW') + ' ' + this.props.name}</Button> */}
              </>
            )}
          </DialogTitle>
          <DialogContent dividers>
            <Paper className={classes.paper} elevation={0}>
              {this.state.step == 1 && (
                <>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>
                      <div className={classes.searchOuterDiv}>
                        {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          !this.props.tenantRoles.includes(
                            "CHILD_PROVIDER",
                          ) && (
                            <div className={classes.searchInputDiv}>
                              {/* <FormControlLabel
                                                            control={
                                                                <Checkbox color="primary" checked={this.state.partnerProducts} name="partnerProducts" onChange={(e) => this.togglePartnerProducts(e)} />
                                                            }
                                                            label={this.props.t('PARTNER_PRODUCTS')}
                                                        /> */}
                              <FormControlLabel
                                control={
                                  <Switch
                                    color="primary"
                                    checked={this.state.partnerProducts}
                                    name="partnerProducts"
                                    onChange={(e) =>
                                      this.togglePartnerProducts(e)
                                    }
                                  />
                                }
                                label={this.props.t("PARTNER_PRODUCTS")}
                              />
                            </div>
                          )}
                        {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          !this.props.tenantRoles.includes(
                            "CHILD_PROVIDER",
                          ) && (
                            <>
                              <div className={classes.searchInputDiv}>
                                {this.state.partnerProducts && (
                                  <FormControl
                                    variant="outlined"
                                    className="custom-select-input-white-label"
                                    style={{ width: "200px", float: "right" }}
                                  >
                                    <InputLabel htmlFor={"selectedPartner"}>
                                      {t("PARTNER")}
                                    </InputLabel>
                                    <Select
                                      value={this.state.selectedPartner}
                                      native
                                      label={t("PARTNER")}
                                      onChange={(e) =>
                                        this.handlePartnerSelection(e)
                                      }
                                      inputProps={{
                                        name: "selectedPartner",
                                        id: "selectedPartner",
                                      }}
                                    >
                                      <option value="-">Select</option>
                                      {this.state.partnerList.map((partner) => (
                                        <option
                                          key={partner.id}
                                          value={partner.id}
                                        >
                                          {partner.groupName}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                )}
                              </div>
                            </>
                          )}
                        <div className={classes.searchInputDiv}>
                          <Input
                            size={"small"}
                            variant={"outlined"}
                            placeholder={t("NAME")}
                            value={this.state.searchFilter.name}
                            name={"name"}
                            onChange={(e) => {
                              this.updateFilter(e);
                            }}
                            divClass={classes.inputClass}
                            onKeyDown={(e) => {
                              this.onSearchKeyDown(e);
                            }}
                          />
                        </div>
                        {this.props.component !== "PROD_COMP_PACKAGE" && (
                          <div className={classes.searchInputDiv}>
                            <Input
                              size={"small"}
                              variant={"outlined"}
                              placeholder={t("PRODUCT_CODE")}
                              value={this.state.searchFilter.featureCode}
                              name={"featureCode"}
                              onChange={(e) => {
                                this.updateFilter(e);
                              }}
                              divClass={classes.inputClass}
                              onKeyDown={(e) => {
                                this.onSearchKeyDown(e);
                              }}
                            />
                          </div>
                        )}
                        <div className={classes.searchInputDiv}></div>
                        <div className={classes.searchOrderLabelOuter}>
                          <div className={classes.searchOrderLabelInner}>
                            <Tooltip title={t("SEARCH")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.filterComponents}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>{" "}
                            &nbsp;
                            <Tooltip title={t("CLEAR")}>
                              <IconButton
                                className="iconButtonSecondary"
                                onClick={this.clearFilters}
                              >
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Box
                      className="roundCorners"
                      style={{
                        border: "1px solid lightgrey",
                        // marginTop: "1rem",
                      }}
                    >
                      <TableContainer>
                        <Table
                          className="newGlobalTable"
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              {/* <TableCell>
                                                                <b>{t('SELECT')}</b>
                                                            </TableCell> */}
                              <TableCell>
                                <b>{t("PROVIDER")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("TYPE")}</b>
                              </TableCell>
                              {this.props.component !== "PROD_COMP_PACKAGE" && (
                                <TableCell>
                                  <b>{t("IS_SELLABLE")}</b>
                                </TableCell>
                              )}
                              <TableCell
                                className="global-custom-sorting-header"
                                onClick={(e) => {
                                  this.updateSorting("productName");
                                }}
                              >
                                <b
                                  style={{ position: "relative", top: "-4px" }}
                                >
                                  {t("NAME")}
                                </b>
                                {this.state.sortBy === "productName" ? (
                                  <span className="material-icons">
                                    {this.state.sortOrder === "DESC"
                                      ? "expand_less"
                                      : "expand_more"}
                                  </span>
                                ) : (
                                  <span className="material-icons sorting-indicator-icon">
                                    unfold_more
                                  </span>
                                )}
                              </TableCell>
                              {this.props.component === "PROD_COMP_PACKAGE" ? (
                                <TableCell>
                                  <b>{t("PRICE")}</b>
                                </TableCell>
                              ) : (
                                <TableCell
                                  align="center"
                                  className="global-custom-sorting-header"
                                  onClick={(e) => {
                                    this.updateSorting("price");
                                  }}
                                >
                                  <b
                                    style={{
                                      position: "relative",
                                      top: "-4px",
                                    }}
                                  >
                                    {t("PRICE")} ({currencyFormatter("", false)}
                                    )
                                  </b>
                                  {this.state.sortBy === "price" ? (
                                    <span className="material-icons">
                                      {this.state.sortOrder === "DESC"
                                        ? "expand_less"
                                        : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                              )}
                              {this.props.component !== "PROD_COMP_PACKAGE" && (
                                <TableCell
                                  align="center"
                                  className="global-custom-sorting-header"
                                  onClick={(e) => {
                                    this.updateSorting("productCode");
                                  }}
                                >
                                  <b
                                    style={{
                                      position: "relative",
                                      top: "-4px",
                                    }}
                                  >
                                    {t("PRODUCT_CODE")}
                                  </b>
                                  {this.state.sortBy === "productCode" ? (
                                    <span className="material-icons">
                                      {this.state.sortOrder === "DESC"
                                        ? "expand_less"
                                        : "expand_more"}
                                    </span>
                                  ) : (
                                    <span className="material-icons sorting-indicator-icon">
                                      unfold_more
                                    </span>
                                  )}
                                </TableCell>
                              )}
                              {
                                <TableCell align="center">
                                  <b>{t("STATUS")}</b>
                                </TableCell>
                              }
                              {/* {(this.props.component == 'DEVICE_COMPONENT' || this.props.component == 'ACC_COMPONENT') &&
                                                <TableCell align="center"><b>{t('IMAGE')}</b></TableCell>
                                            } */}
                              {/* <TableCell align="center"><b>{t('Listing Order')}</b></TableCell> */}
                              {/* {this.props.component !== 'SOLUTION_PLAN_COMPONENT' &&
                                                <TableCell align="center"><b>{t('Applicable To?')}</b></TableCell>
                                            } */}
                              <TableCell
                                align="center"
                                style={{ minWidth: "60px" }}
                              >
                                <b>{t("ACTION")}</b>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.data.map((item, index) => (
                              <TableRow
                                key={index}
                                hover
                                style={{ cursor: "pointer" }}
                              >
                                {/* <TableCell align='center'>
                                                                    {this.state.selectedToAdd.find(selected => selected.featureCode === item.featureCode) ? (
                                                                        <Tooltip title={t('UNSELECT_PRODUCT', item)}>
                                                                            <Checkbox
                                                                                color="primary"
                                                                                checked={true}
                                                                                onChange={() => updateSelection(item)}
                                                                                name={item.name}
                                                                            />
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip title={t('SELECT_PRODUCT', item)}>
                                                                            <Checkbox
                                                                                color="primary"
                                                                                checked={false}
                                                                                onChange={() => updateSelection(item)}
                                                                                name={item.name}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                </TableCell> */}
                                <TableCell>{item.fromProviderName}</TableCell>
                                <TableCell>
                                  {item.bom && item.bom.length > 0 ? (
                                    <Tooltip
                                      title={t("BOM")}
                                      style={{
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                      }}
                                    >
                                      {/* <GroupWorkIcon /> */}
                                      <FilterNoneOutlined />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title={t("PRODUCT")}
                                      style={{
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                      }}
                                    >
                                      {/* <Filter1Icon /> */}
                                      <LooksOneOutlined />
                                    </Tooltip>
                                  )}
                                </TableCell>
                                {this.props.component !==
                                  "PROD_COMP_PACKAGE" && (
                                    <TableCell>
                                      {item.sellable && <CheckCircleIcon />}
                                    </TableCell>
                                  )}
                                <TableCell>{item.name}</TableCell>
                                <TableCell align="center">
                                  {item.price
                                    ? currencyFormatter(item.price)
                                    : currencyFormatter("", false) + "0.00"}
                                  &nbsp;
                                  {item.priceType ? t(item.priceType) : ""}{" "}
                                  {item.priceType === "NTC"
                                    ? item.priceTenure > 1
                                      ? "(" +
                                      "per " +
                                      item.priceTenure +
                                      " " +
                                      getPriceTenureUOM(item.priceTenureUOM) +
                                      "s" +
                                      ")"
                                      : "(" +
                                      "per " +
                                      item.priceTenure +
                                      " " +
                                      getPriceTenureUOM(item.priceTenureUOM) +
                                      ")"
                                    : ""}
                                  {item.priceType === "RC"
                                    ? item.priceTenure
                                      ? item.priceTenure > 1
                                        ? "(" +
                                        "per " +
                                        item.priceTenure +
                                        " " +
                                        getPriceTenureUOM(
                                          item.priceTenureUOM,
                                        ) +
                                        "s" +
                                        ")"
                                        : "(" +
                                        "per " +
                                        getPriceTenureUOM(
                                          item.priceTenureUOM,
                                        ) +
                                        ")"
                                      : ""
                                    : ""}
                                  {/* code for quarterly */}
                                  {/* {item.priceType === 'RC' ? item.priceTenureUOM ? (item.priceTenure === 3 && item.priceTenureUOM === 'TF_mon') ? '(' + getPriceTenureUOM('TF_qtr') + ')' :
                                                                '(' + getPriceTenureUOM(item.priceTenureUOM) + ')' :
                                                                '(' + getPriceTenureUOM('TF_mon') + ')' : ''} */}
                                </TableCell>
                                {this.props.component !==
                                  "PROD_COMP_PACKAGE" && (
                                    <TableCell align="center">
                                      {item.featureCode}
                                    </TableCell>
                                  )}
                                {
                                  <TableCell align="center">
                                    {item.statusDisplayName}
                                  </TableCell>
                                }
                                {/* {(this.props.component == 'DEVICE_COMPONENT' || this.props.component == 'ACC_COMPONENT') &&
                                                    <TableCell>
                                                        <img src={item.largeImageUrl ? (constants.imageUrl + item.largeImageUrl) : placeholderImage} style={{ width: '25px', height: '25px' }} />
                                                    </TableCell>
                                                } */}
                                {/* <TableCell>{item.listingOrder}</TableCell> */}
                                {/* {this.props.component !== 'SOLUTION_PLAN_COMPONENT' &&
                                                    <TableCell>
                                                        {item.applicableTo
                                                            .map((opt, i) => (
                                                                <Tooltip title={opt.solutionName + " - " + (opt.extraPlanOptionDesc ? opt.extraPlanOptionDesc : '')} aria-label="solutionPlan">
                                                                    <Chip key={i} label={this.getShortenedChipName(opt.solutionName + " - " + (opt.extraPlanOptionDesc ? opt.extraPlanOptionDesc : ''))} color="primary" variant="outlined" style={{ marginBottom: 5 }} />
                                                                </Tooltip>
                                                            ))}
                                                    </TableCell>
                                                } */}
                                <TableCell align="center">
                                  <div
                                    style={{ display: "flex", gap: ".25rem" }}
                                  >
                                    <Button
                                      style={{display:'flex', height: '30.5px', alignItems: 'center'}}
                                      className="buttonSecondary"
                                      onClick={(event) =>
                                        this.props.close(item)
                                      }
                                    >
                                      <PlusIcon />
                                    </Button>
                                    {/* <Tooltip title={t('ADD')} style={{ paddingTop: 0, paddingBottom: 0 }} onClick={event => this.props.close(item)}>
                                                                <AddCircleIcon />
                                                            </Tooltip> &nbsp; */}
                                    {
                                      this.props.component !==
                                      "PROD_COMP_PACKAGE" && (
                                        <Button
                                          style={{display:'flex', height: '30.5px', alignItems: 'center'}}
                                          className="buttonSecondary"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.viewComponent(item);
                                          }}
                                        >
                                          <ViewIconNew />
                                        </Button>
                                      )
                                      // <Tooltip title={t('VIEW_RESOURCES')} onClick={(e) => { e.stopPropagation(); this.viewComponent(item) }}>
                                      //     <VisibilityIcon />
                                      // </Tooltip>
                                    }
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                            {this.state.data.length === 0 && (
                              <TableRow>
                                <TableCell colSpan={8} align="center">
                                  {t("NO_ITEMS_DEFINED")}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {this.state.totalProductsCount > 0 && (
                        <div
                          className="global-custom-pagination"
                          style={{ background: "rgba(196, 196, 196, 0.2)" }}
                        >
                          <label style={{ float: "left", padding: "5px" }}>
                            {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalProductsCount)}
                          </label>
                          <label>
                            {/* Rows per page select */}
                            {t("ROWS_PER_PAGE")}
                            <Select
                              value={this.state.perPage}
                              onChange={this.changeRowsPerPage}
                            >
                              <MenuItem
                                value={10}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                10
                              </MenuItem>
                              <MenuItem
                                value={50}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                50
                              </MenuItem>
                              <MenuItem
                                value={100}
                                classes={{ root: "treeRowPerPageItem" }}
                              >
                                100
                              </MenuItem>
                            </Select>
                          </label>
                          {/* Pagination component */}
                          <Pagination
                            page={this.state.page}
                            count={Math.ceil(
                              this.state.totalProductsCount /
                              this.state.perPage,
                            )}
                            onChange={this.changePage}
                            showFirstButton
                            showLastButton
                          />
                        </div>
                      )}
                    </Box>
                  </div>
                </>
              )}
              {this.state.step === 2 && (
                <ConfigurationResource
                  // provising data
                  provisioningResources={this.state.provisioningResources}
                  fulfilmentConnectionFields={
                    this.state.fulfilmentConnectionFields
                  }
                  fulfilmentTableFields={this.state.fulfilmentTableFields}
                  fulfilmentTableEditable={this.state.fulfilmentTableEditable}
                  showDefaultValue={this.state.showDefaultValue}
                  selectedFulfilmentResource={
                    this.state.selectedFulfilmentResource
                  }
                  // activation data
                  activationResources={this.state.activationResources}
                  activationConnectionFields={
                    this.state.activationConnectionFields
                  }
                  activationTableFields={this.state.activationTableFields}
                  activationTableEditable={this.state.activationTableEditable}
                  activationFile={this.state.activationFile}
                  selectedActivationResource={
                    this.state.selectedActivationResource
                  }
                  // Suspend resource
                  suspendResources={this.state.suspendResources}
                  suspendConnectionFields={this.state.suspendConnectionFields}
                  suspendTableFields={this.state.suspendTableFields}
                  suspendTableEditable={this.state.suspendTableEditable}
                  selectedSuspendResource={this.state.selectedSuspendResource}
                  // Resume resource
                  resumeResources={this.state.resumeResources}
                  resumeConnectionFields={this.state.resumeConnectionFields}
                  resumeTableFields={this.state.resumeTableFields}
                  resumeTableEditable={this.state.resumeTableEditable}
                  selectedResumeResource={this.state.selectedResumeResource}
                  priceType={this.state.selectedToView.priceType}
                  readonly={true}
                />
              )}
              {this.state.step === 3 && (
                <TableContainer>
                  <Table>
                    <ComponentAssembly
                      data={this.state.selectedToView}
                      expandVariants={true}
                    />
                  </Table>
                </TableContainer>
              )}
            </Paper>
          </DialogContent>

          <DialogActions>
            {/* <Button onClick={event => this.props.close()} color="primary">Yes</Button> */}
            {this.state.step === 1 && (
              <>
                <Button
                  className="buttonSecondary"
                  onClick={(event) => this.props.close()}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                {/* {(this.state.selectedToAdd && this.state.selectedToAdd.length > 0) && <Button onClick={() => {
                                    this.props.bulkAddBucketItem(this.state.selectedToAdd);
                                    this.props.close();
                                }} color="primary">{t('ADD')}</Button>} */}
              </>
            )}
            {this.state.step === 2 && (
              <>
                <Button
                  onClick={(event) => {
                    this.clearSelectedItemResourcesTable();
                    this.setState({ step: 1 });
                  }}
                  color="primary"
                >
                  {t("BACK")}
                </Button>
                <Button
                  onClick={(event) => {
                    this.clearSelectedItemResourcesTable();
                    this.props.close();
                  }}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                {this.state.selectedToView.assembly && (
                  <Button
                    onClick={(event) => {
                      this.setState({ step: 3 });
                    }}
                    color="primary"
                  >
                    {t("NEXT")}
                  </Button>
                )}
                <Button
                  onClick={(event) => {
                    this.clearSelectedItemResourcesTable();
                    this.props.close(this.state.selectedToView);
                  }}
                  color="primary"
                >
                  {t("ADD")}
                </Button>
              </>
            )}
            {this.state.step === 3 && (
              <>
                <Button
                  onClick={(event) => {
                    this.setState({ step: 2 });
                  }}
                  color="primary"
                >
                  {t("BACK")}
                </Button>
                <Button
                  onClick={(event) => {
                    this.clearSelectedItemResourcesTable();
                    this.props.close();
                  }}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={(event) => {
                    this.clearSelectedItemResourcesTable();
                    this.props.close(this.state.selectedToView);
                  }}
                  color="primary"
                >
                  {t("ADD")}
                </Button>
              </>
            )}
          </DialogActions>
          <Loader loading={this.state.loading} />
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    tenantRoles: state.auth.tenantRoles,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PackageTemplate));
